var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "16px",
    viewBox: "0 0 26 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D2387C7E-0FE8-4FC5-824C-0F3876993036@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empresas-movil",
    transform: "translate(-333.000000, -18.000000)",
    fill: "#263238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.736842,31.4736842 C358.434465,31.4736842 359,32.0392193 359,32.7368421 C359,33.4344649 358.434465,34 357.736842,34 L334.263158,34 C333.565535,34 333,33.4344649 333,32.7368421 C333,32.0392193 333.565535,31.4736842 334.263158,31.4736842 L357.736842,31.4736842 Z M357.736842,24.7368421 C358.434465,24.7368421 359,25.3023772 359,26 C359,26.6976228 358.434465,27.2631579 357.736842,27.2631579 L334.263158,27.2631579 C333.565535,27.2631579 333,26.6976228 333,26 C333,25.3023772 333.565535,24.7368421 334.263158,24.7368421 L357.736842,24.7368421 Z M357.736842,18 C358.434465,18 359,18.5655351 359,19.2631579 C359,19.9607807 358.434465,20.5263158 357.736842,20.5263158 L334.263158,20.5263158 C333.565535,20.5263158 333,19.9607807 333,19.2631579 C333,18.5655351 333.565535,18 334.263158,18 L357.736842,18 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.de00ae64.svg";
export { ForwardRef as ReactComponent };